module.exports = __webpack_public_path__ + "static/media/sack-dollar.6e49524b.svg";